export type Suit = 'spades' | 'hearts' | 'diamonds' | 'clubs';
export type Rank = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13;
export type Color = 'red' | 'black';

export const SUITS: readonly Suit[] = ['spades', 'hearts', 'diamonds', 'clubs'];
export const RANKS: readonly Rank[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];

export interface Card {
  readonly id: string;
  readonly suit: Suit;
  readonly rank: Rank;
  faceUp: boolean;
}

export function color(card: Card): Color {
  return card.suit === 'hearts' || card.suit === 'diamonds' ? 'red' : 'black';
}

export function cardId(suit: Suit, rank: Rank): string {
  return `${suit[0]}${rank}`;
}

/**
 * Build a deck of 52 × `numDecks` cards. Single-deck IDs are `${suit[0]}${rank}`
 * (e.g. `s13` for spade king). When `numDecks > 1`, IDs are suffixed with the
 * deck index - `s13_0`, `s13_1` - so every card in the resulting array is
 * unique even though duplicates exist by suit/rank. Spider needs this.
 */
export function createDeck(numDecks = 1): Card[] {
  const deck: Card[] = [];
  for (let d = 0; d < numDecks; d++) {
    for (const suit of SUITS) {
      for (const rank of RANKS) {
        const id = numDecks === 1 ? cardId(suit, rank) : `${cardId(suit, rank)}_${d}`;
        deck.push({ id, suit, rank, faceUp: false });
      }
    }
  }
  return deck;
}
